import React from 'react';
import OverviewAccountSkeleton from "../skeletons/OverviewAccountSkeleton";
import {formatAccount} from "../../features/ValueFormater";

function AccountsSection({EntityType, accountLoading, data, currency}) {

    return (
        <>
            {!accountLoading ? (
                <div className="col-lg-5 col-md-12 col-sm-12">
                    {
                        EntityType === "LEGALENTITY" ? (
                            <>
                                <div className="row accountDetail">
                                    <div className="accountType">{currency==="$"? "USD": currency} ACCOUNT</div>
                                    <div
                                        className="accountamount">{currency === "$" ? formatAccount(data?.Available, 1) : formatAccount(data.Available, 2)}
                                    </div>
                                </div>
                                <div className="row status">

                                    <div className="col-4 Available">
                                        <div
                                            className="amo">{currency === "$" ? formatAccount(data?.Available, 1) : formatAccount(data?.Available, 2)}
                                        </div>
                                        <div className="typ">Available</div>
                                    </div>
                                    <div className="col-4 Available">
                                        <div
                                            className="amo">{currency === "$" ? formatAccount(data?.Book, 1) : formatAccount(data?.Book, 2)}
                                        </div>
                                        <div className="typ">Book</div>
                                    </div>
                                    <div className="col-4 Available">
                                        <div
                                            className="amo">{currency === "$" ? formatAccount(data?.Held, 1) : formatAccount(data?.Held, 2)}
                                        </div>
                                        <div className="typ">Held</div>
                                    </div>
                                </div>
                            </>

                        ) : (
                            <div className="row accountDetail">
                                <div className="accountType">TOTAL SALES ({currency === '$' ? "USD" : "LBP"})</div>
                                <div
                                    className="accountamount">{currency === "$" ? formatAccount(data, 1) : formatAccount(data, 2)}
                                </div>
                            </div>
                        )
                    }

                </div>
            ) : (
                <OverviewAccountSkeleton/>
            )}
        </>
    );
}

export default AccountsSection;